import styled from '@emotion/styled';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';

function FaqCategoryChoice(props: BaseMsgProps) {
  const { faqCategoryChoiceContent } = props.raw;

  if (!faqCategoryChoiceContent) {
    return <></>;
  }

  return (
    <MessageExtendComplex
      {...props}
      content={<Container>{faqCategoryChoiceContent.text}</Container>}
    />
  );
}

const Container = styled.div`
  max-width: 450px;
  padding: 8px 12px;
  border-radius: 4px;
  background: #fff;
`;

export default FaqCategoryChoice;
